import { render } from "./FirstMountedOverlay.vue?vue&type=template&id=30c9188a&scoped=true"
import script from "./FirstMountedOverlay.vue?vue&type=script&lang=js"
export * from "./FirstMountedOverlay.vue?vue&type=script&lang=js"

import "./FirstMountedOverlay.vue?vue&type=style&index=0&id=30c9188a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30c9188a"]])

export default __exports__